import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const IMAGES = {
  heroBlack:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/44e5a82a0b83354d76f862d892d67fb53f292a2b579abda8720a6ddb87841d76.png",
  productAngle:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/b38731c77187114b687853487ef90af92bf95972b76e2aa67be232c9f5ae4a18.png",
  stylusDetail:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/b46e10559a97d46c8926adf9e4499a253c1ff065999ec231bc6727115acd7c5f.png",
  lifestyle:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/59dff342593c5853f3f1ef5aa84b56f2fe4037c5aeadddfae7273f4c879f0d93.png",
  flatSnap:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/6d249fb625f3ff44a3570ee595d220cb7d61313301305664234bf785b00b7e9e.png",
  flatPrototype:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/ff28e98ba2642497fdf11d9b5b7599490c0d6813de065ce1248df70f377b1f96.png",
  flatPair:
    "https://static.prod-images.emergentagent.com/jobs/f4143fde-342b-4a23-ab0a-e3099b4edc92/images/6f5417d328952f0ab8df7e389ac956cd6f4daca76276655d1482d7232c69fd8d.png",
};
